import { ActionIcon, Anchor, Button, Center, Group, Modal, Paper, Select, Table, Text, TextInput, Title, Tooltip, useMantineTheme } from "@mantine/core";
import { IconPlus } from "@tabler/icons";
import { useContext, useState } from "react"
import { Plus } from "tabler-icons-react";
import { AuthContext } from "../../App"
import axios from "../../utils/axios";
import { BreadcrumbsSlash } from "../BreadCrumbs";

export default function TenantDashboard(){
    const { state, dispatch } = useContext(AuthContext);
    const [opened, setOpened] = useState(false);
    const items = [
        {title: 'app', href: '/tenant/'},
        { title: 'Dashboard', href: '#'},
    ].map((item, index) => (
        <Anchor size="xs" href={item.href} key={index}>
            {item.title}
        </Anchor>
    ));

    const theme = useMantineTheme();
    const makePayments = () => {
        axios.post("/simulate/pay", {
            partyA: 254741582811,
            phone: 254741582811
        }).then(function(res){
            console.log(res);
        })
    }

    return (
        <>
        <Group position="apart">
            <Group position="left">
                <Title order={4} weight={300}>Welcome, {state.userData.username}</Title>
            </Group>
            <Group position="right">
                <BreadcrumbsSlash items={items} />
            </Group>
        </Group>

        <Modal opened={opened} closeOnClickOutside={false} closeOnEscape={false} onClose={() => {setOpened(false)}} centered title="Make payment">
            <Text mb={20} size="xs">Select the house and specific unit to pay for. We are currently supporting M-Pesa transactions only.</Text>

                        <Group mb={20} grow>
                            <Group position="left">
                                <Text size='xs'>Select House</Text>
                            </Group>
                            <Group>
                            <Select data={[]} placeholder='select one' size='xs'  />
                            </Group>
                        </Group>

                        <Group mb={20} grow>
                            <Group position="left">
                                <Text size='xs'>Room</Text>
                            </Group>
                            <Group>
                            <TextInput placeholder='' size='xs'  />
                            </Group>
                        </Group>

                        <Button onClick={() => {makePayments()}} >Continue</Button>
        </Modal>
        <Paper mt="lg" shadow="sm" p="md">
            <Group spacing="lg" position="right">
                <Tooltip label="New Payment">
                    <ActionIcon onClick={() => {setOpened(true)}} >
                        <IconPlus />
                    </ActionIcon>
                </Tooltip>
            </Group>

            <Group mb={20} position="apart">
                <Group position="left">
                <TextInput placeholder='Search transaction' size='xs' radius={28} />
                </Group>
            </Group>

            <div style={{overflowX: 'auto'}}>
                <Table fontSize="xs">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Transaction ID</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={7}>
                                <Center>
                                    <Text size="xs">No data is available</Text>
                                </Center>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </Paper>

        </>
    )
}